import React from "react";

export default class nonDelegation extends React.Component {

}